import angular from 'angular';
import { ForwardMailListComponent } from './list.component';
import { ForwardMailListComponent as UdsForwardMailListComponent } from '../../new-design/list/list.component';
import { ForwardMailListConfig } from './list.config';
import { ForwardMailFormModule } from '../form';
import { CardModule } from '../../../../core';
import {
  RelevantContentComponent,
  StepPageModule,
} from '../../../../common/directives';

export const ForwardMailListModule = angular
  .module('app.steps.forward-mail.list', [
    ForwardMailFormModule.name,
    RelevantContentComponent.name,
    StepPageModule.name,
    CardModule.name,
  ])
  .config(ForwardMailListConfig)
  .component('updForwardMailList', ForwardMailListComponent)
  .component('udsForwardMailList', UdsForwardMailListComponent);
